/*
 * Every rails layout should have a "csrf-token" meta tag
 */
export default () => {
  const csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
  const csrfToken = csrfTokenMeta && csrfTokenMeta.getAttribute('content');

  return csrfToken;
};
